module.exports = __webpack_public_path__ + "img/icon-28.939c2246.png";